import React, { Component } from 'react';
import Button from './Shared/Button'
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';

export default class DescriptivePage extends Component {

    render(){
        const {style, description, followingScreen, altButtonTitle, textSize, allowNext } = this.props;
        const padding = 28;

        let descriptionText;
        if(textSize === `normal`){ 
            descriptionText = <div>{FormatText(global.isMale,description)}</div>
        }
        if(textSize === `medium`){ 
            descriptionText = <h3>{FormatText(global.isMale,description)}</h3>
        }
        if(textSize === `large`){ 
            descriptionText = <h2>{FormatText(global.isMale,description)}</h2>
        }

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "המשך";

        // const description = Object.keys(descriptions).length > 1 ? descriptions[global.group] : descriptions["all"];

        // console.log( this.props );
        // console.log( "allowNext: " + allowNext );

        return <div style={style}>
            <SurveyRect {...this.props} H={440}>
                <div key={'p1'} className="paragraph" style={{
                     position: "absolute",
                     top: padding -12,
                     right: padding,
                     left: padding,
                     textAlign: "right",
                }}>{descriptionText}</div>
                <Button style={{
                    position:"absolute",
                    left:padding,
                    bottom:padding,
                }} text={buttonText} isActive={allowNext} onClick={() => {
                    // validate & save
                    global.nextStage(followingScreen);
                }}/>

            </SurveyRect>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/Comp/DescriptivePage.js